/**
 * This file holds computed state properties
 * Please refer to https://vuex.vuejs.org/guide/getters.html for more information
 */

const getters = {
  isSelectedColorsComplete(store) {
    for (let key in store.selectedColors) {
      if (store.selectedColors[key] === "") {
        return false;
      }
    }
    return true;
  },
  getSelectedColorsIds(store) {
    let colors = [];
    for (let color in store.selectedColors) {
      colors.push(store.selectedColors[color]);
    }
    return colors;
  },
  getUrlParameterByName() {
    return name => {
      const url = window.location.href;
      name = name.replace(/\[\]/g, "\\$&");
      const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
      const results = regex.exec(url);

      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    };
  },
  isLoadRandomizer(store, getters, rootState) {
    const loadRandomizer = getters.getUrlParameterByName("loadRandomizer") || rootState.utils.queryParams.canvas;
    return loadRandomizer;
  },
  /**
   * @function tallyOfChangesInColorPalette
   * @returns {number} When an error occurs, returns -1. Otherwise,
   * returns the number times a user has (re)selected a color swatch in the color palette.
   */
  tallyOfChangesInColorPalette(store) {
    return (typeof store.tallyOfChangesInColorPalette !== 'number'
      || isNaN(store.tallyOfChangesInColorPalette)
      || store.tallyOfChangesInColorPalette < 0) ?
      0 : store.tallyOfChangesInColorPalette;
  }
};

export default getters;
